module.exports = __webpack_public_path__ + "img/thumbnail_WesternChimpanzee_f_normal.bedf7354.png";